/**
 * Theme helpers for the Talos SPA.
 *
 * Supports three modes stored under 'talos-theme' in localStorage:
 *   "auto"  — follow the system preference (default)
 *   "light" — force light theme
 *   "dark"  — force dark theme
 *
 * The theme is applied via the ``data-theme`` attribute on <html>.  In
 * auto mode a ``prefers-color-scheme`` media query drives the choice.
 */

const KEY = 'talos-theme';
let mq = null; // MediaQueryList for auto mode

function apply(name) {
  if (mq) {
    mq.removeEventListener('change', onSystemChange);
    mq = null;
  }
  if (name === 'auto') {
    const dark = window.matchMedia('(prefers-color-scheme: dark)');
    mq = dark;
    dark.addEventListener('change', onSystemChange);
    document.documentElement.setAttribute('data-theme', dark.matches ? 'dark' : 'light');
  } else {
    document.documentElement.setAttribute('data-theme', name);
  }
}

function onSystemChange(e) {
  document.documentElement.setAttribute('data-theme', e.matches ? 'dark' : 'light');
}

export function getTheme() {
  return localStorage.getItem(KEY) || 'auto';
}

export function setTheme(theme) {
  localStorage.setItem(KEY, theme);
  apply(theme);
}

// Apply the stored theme when the module loads.
apply(getTheme());